import React from 'react';
import './CrisisPopup.css';

const CrisisPopup = ({ isVisible = true, onClose, onSaveResources, onSafelyClose }) => {
  if (!isVisible) return null;

  const crisisResources = [
    "Kids Help Phone: 1-800-668-6868 | Text 686868 | kidshelpphone.ca",
    "National LGBTQ Youth Talk Line: 1-800-246-7743",
    "Trans Lifeline: 1-877-330-6366 | translifeline.org",
    "1-800-SUICIDE: 1-800-784-2433"
  ];

  return (
    <div className="crisis-popup-overlay">
      <div className="crisis-popup">
        <div className="crisis-header">
          <span className="crisis-heart">💛</span>
          <h2>We care about you.</h2>
        </div>
        
        <div className="crisis-content">
          <p>We noticed you might be going through a difficult time. We are so glad you said something.</p>
          <p>It is okay to feel overwhelmed, and there is always support and folks who care! You're important.</p>
          
          <div className="crisis-suggestions">
            <h3>We suggest you:</h3>
            <ol>
              <li>Talk with someone you trust</li>
              <li>Visit a health care provider</li>
              <li>Call a helpline if you wish to stay anonymous</li>
            </ol>
          </div>
          
          <div className="crisis-resources">
            <h3>The following are great options:</h3>
            {crisisResources.map((resource, index) => (
              <div key={index} className="crisis-resource-item">
                {resource}
              </div>
            ))}
          </div>
        </div>
        
        <div className="crisis-buttons">
          <button 
            className="crisis-button secondary"
            onClick={onClose}
          >
            Skip for now and keep chatting
          </button>
          <button 
            className="crisis-button primary"
            onClick={onSaveResources}
          >
            Save these resources as a PDF
          </button>
          <button 
            className="crisis-button danger"
            onClick={() => {
              if (window.confirm('Are you sure you want to safely close the chat?')) {
                onSafelyClose();
              }
            }}
          >
            Safely close the chat
          </button>
        </div>
      </div>
    </div>
  );
};

export default CrisisPopup; 